import React from "react";
import { Snackbar as MuiSnackbar } from "@mui/material";
import styled from "styled-components";

const StyledSnackbar = styled(MuiSnackbar)``;

/**
 * A wrapper component for Material-UI's Snackbar that displays brief messages.
 *
 * @component
 * @param {Object} props - The component props
 * @param {boolean} props.open - Controls the visibility of the snackbar
 * @param {Function} props.onClose - Callback fired when the snackbar is closed
 * @param {string} props.message - The message to be displayed in the snackbar
 * @param {Object} [props.anchorOrigin={ vertical: "bottom", horizontal: "left" }] - Object defining the anchor position of the snackbar
 * @param {('top'|'bottom')} props.anchorOrigin.vertical - Vertical anchor position
 * @param {('left'|'center'|'right')} props.anchorOrigin.horizontal - Horizontal anchor position
 * @param {number} [props.autoHideDuration=10000] - The duration in milliseconds before automatically closing
 * @returns {React.ReactElement} A styled Material-UI Snackbar component
 *
 * @example
 * <Snackbar
 *   open={isOpen}
 *   onClose={() => setIsOpen(false)}
 *   message="Operation successful!"
 * />
 */
export const Snackbar = ({
  open,
  onClose,
  message,
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  autoHideDuration = 10000,
  children,
}) => {
  return (
    <StyledSnackbar
      open={open}
      onClose={onClose}
      message={message}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
    >
      {children}
    </StyledSnackbar>
  );
};
